/** Default center/location values for quick-create business service (legacy parity). */
export const QUICK_CREATE_LOCATION_DEFAULTS = Object.freeze({
  address: 'Delhi',
  latitude: '',
  longitude: '',
  radius: 2,
  subarea: 'Basant Lok',
  area: 'Vasant Vihar',
  city: 'Delhi NCR',
  pincode: '201309',
  codes: ['RS'],
});

/**
 * Builds the API payload for quick-create initial proposal.
 * Mirrors legacy CreateProposal quick-create submit shape.
 *
 * @param {{ name: string, tentativeBudget: string|number, costOfLeads: string|number, accountId: string, organisationId: string }} params
 */
export function buildQuickCreateProposalPayload({
  name,
  tentativeBudget,
  costOfLeads,
  accountId,
  organisationId,
}) {
  const trimmedName = String(name || '').trim();
  const principalVendor = organisationId || '';
  const account_id = accountId || '';

  return {
    centers: [
      {
        center: {
          center_name: trimmedName,
          ...QUICK_CREATE_LOCATION_DEFAULTS,
        },
      },
    ],
    vendorData: [1, 2, 3],
    brand: 'single_brand',
    name: trimmedName,
    tentative_cost: Number(tentativeBudget),
    cost_of_lead: Number(costOfLeads),
    principal_vendor: principalVendor,
    account_id,
    organisation_id: principalVendor,
    description: '',
  };
}

/**
 * Extracts created proposal/workspace id from create-initial-proposal response.
 * @param {object} response
 * @returns {string}
 */
export function extractCreatedProposalId(response) {
  const data = response?.data?.data ?? response?.data ?? {};
  return String(
    data?.proposal_id
    ?? data?.id
    ?? data?.data
    ?? ''
  );
}
